import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from './utils/analytics';

const useGaTracker = () => {
  const location = useLocation();
  const googleKey = window.platform_info.google_analytics_key;

  useEffect(() => {
    initGA(googleKey);
  }, [googleKey]);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
};

export default useGaTracker;
